module.exports = __webpack_public_path__ + "img/logoMini.25884b2a.svg";